(() => {
  const copy = document.currentScript?.dataset.note;
  if (!copy) return;
  let queued = false;

  function updateNotes() {
    queued = false;
    document.querySelectorAll('.cart__summary, .cart-drawer__summary').forEach((summary) => {
      const toggle = summary.querySelector('redo-shopify-toggle');
      const notes = [...summary.querySelectorAll('.f47-checkout-plus-note')];
      if (!toggle) {
        notes.forEach((note) => note.remove());
        return;
      }
      const note = notes.shift() || document.createElement('p');
      notes.forEach((duplicate) => duplicate.remove());
      note.className = 'f47-checkout-plus-note';
      if (note.textContent !== copy) note.textContent = copy;
      if (summary.lastElementChild !== note) summary.appendChild(note);
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(updateNotes);
  }

  function start() {
    updateNotes();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
